export {CollectionState as default};

/**
* Collection State
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class CollectionState {
  /**
   * Defines last item added
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Object}
   */
  last_added;

  /**
   * Defines last item updated
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Object}
   */
  last_updated = {
    'current'  : null,
    'previous' : null,
  };

  /**
   * Defines last item deleted
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Object}
   */
  last_deleted;

  /**
   * Defines last changed timestamp
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  last_changed;

  /**
   * Defines who initiated the changes
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Object}
   */
  initiator;

  /**
   * Sets the last added item
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object} item
   *
   * @return {void}
   */
  setLastAdded(item) {
    this.last_added = item;
    this.setLastChanged();
  }

  /**
   * Sets the last item updated
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object} current
   * @param {Object} previous
   *
   * @return {void}
   */
  setLastUpdated(current, previous) {
    this.last_updated.current  = current;
    this.last_updated.previous = previous;
    this.setLastChanged();
  }

  /**
   * Sets the last item deleted
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object} item
   *
   * @return {void}
   */
  setLastDeleted(item) {
    this.last_deleted = item;
    this.setLastChanged();
  }

  /**
   * Sets the initiator
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} initiator
   *
   * @return {void}
   */
  setInitiator(initiator) {
    this.initiator = initiator;
  }

  /**
   * Sets last changed timestamp to now
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  setLastChanged() {
    this.last_changed = Date.now();
  }
}